(() => {
  if (window.KiiveHomeRefresh) { window.KiiveHomeRefresh.boot(document); return; }
  const instances = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let backdrop = null;
  let backdropHost = null;
  let frame = null;
  const observed = new Set();
  const resize = new ResizeObserver(scheduleBackdrop);
  const mutations = new MutationObserver(scheduleBackdrop);
  function scheduleBackdrop() {
    if (frame === null) frame = requestAnimationFrame(updateBackdrop);
  }
  function updateBackdrop() {
    frame = null;
    const roots = [...document.querySelectorAll('[data-kiive-home-refresh]')];
    observed.forEach(root => {
      if (!roots.includes(root)) { resize.unobserve(root); observed.delete(root); }
    });
    if (!roots.length) {
      if (backdrop) backdrop.remove();
      if (backdropHost) backdropHost.classList.remove('kiive-home-flow-host');
      backdrop = null;
      backdropHost = null;
      mutations.disconnect();
      return;
    }
    const host = roots[0].closest('main');
    if (!host || roots.some(root => !host.contains(root))) return;
    if (host !== backdropHost) {
      if (backdrop) backdrop.remove();
      if (backdropHost) backdropHost.classList.remove('kiive-home-flow-host');
      backdropHost = host;
      backdropHost.classList.add('kiive-home-flow-host');
      backdrop = document.createElement('div');
      backdrop.className = 'kiive-home-flow-background';
      backdrop.setAttribute('aria-hidden', 'true');
      backdropHost.prepend(backdrop);
      mutations.disconnect();
      mutations.observe(backdropHost, { childList: true });
    }
    roots.forEach(root => { if (!observed.has(root)) { resize.observe(root); observed.add(root); } });
    const hostBox = host.getBoundingClientRect();
    const boxes = roots.map(root => root.getBoundingClientRect());
    const top = Math.min(...boxes.map(box => box.top));
    const bottom = Math.max(...boxes.map(box => box.bottom));
    const hero = roots.find(root => root.dataset.layout === 'hero');
    backdrop.style.top = `${top - hostBox.top + host.scrollTop}px`;
    backdrop.style.height = `${bottom - top}px`;
    backdrop.style.setProperty('--ki-flow-base', getComputedStyle(roots[0]).getPropertyValue('--ki-section-bg').trim() || '#141619');
    backdrop.style.setProperty('--ki-flow-hero-height', `${hero ? hero.getBoundingClientRect().height : 700}px`);
  }
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const categories = root.querySelector('.ki-category-rail');
    if (categories) root.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
      const card = categories.querySelector('.ki-category');
      if (card) categories.scrollBy({ left: Number(button.dataset.railStep) * (card.getBoundingClientRect().width + 18), behavior: reduced.matches ? 'instant' : 'smooth' });
    }, { signal }));
    const rail = root.querySelector('.ki-proof-rail');
    let timer = null;
    let paused = reduced.matches || root.dataset.autoplay !== 'true';
    let hovered = false;
    let focused = false;
    const slides = rail ? [...rail.querySelectorAll('.ki-proof-slide')] : [];
    const counter = root.querySelector('[data-review-count]');
    const pause = root.querySelector('[data-review-pause]');
    const current = () => rail && rail.clientWidth ? Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / rail.clientWidth))) : 0;
    function count() { if (counter) counter.textContent = `${current() + 1} of ${slides.length}`; }
    function move(step) {
      if (!rail || !slides.length) return;
      const index = (current() + step + slides.length) % slides.length;
      rail.scrollTo({ left: index * rail.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    function schedule() {
      clearInterval(timer);
      if (!paused && !hovered && !focused && !document.hidden && slides.length > 1) timer = setInterval(() => move(1), Number(root.dataset.interval) || 5000);
      if (pause) { pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? 'Play testimonials' : 'Pause testimonials'); pause.textContent = paused ? '▶' : '⏸'; }
    }
    if (rail) {
      count();
      rail.addEventListener('scroll', count, { signal, passive: true });
      root.querySelectorAll('[data-review-step]').forEach(button => button.addEventListener('click', () => { move(Number(button.dataset.reviewStep)); schedule(); }, { signal }));
      if (pause) pause.addEventListener('click', () => { paused = !paused; schedule(); }, { signal });
      root.addEventListener('mouseenter', () => { hovered = true; schedule(); }, { signal });
      root.addEventListener('mouseleave', () => { hovered = false; schedule(); }, { signal });
      root.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
      root.addEventListener('focusout', event => { focused = root.contains(event.relatedTarget); schedule(); }, { signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      document.addEventListener('shopify:block:select', event => {
        const slide = slides.find(item => item.dataset.reviewId === event.detail.blockId);
        if (slide) { paused = true; slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' }); schedule(); }
      }, { signal });
      reduced.addEventListener('change', () => { if (reduced.matches) paused = true; schedule(); }, { signal });
      schedule();
    }
    instances.set(root, () => { clearInterval(timer); controller.abort(); instances.delete(root); });
  }
  function boot(scope) { scope.querySelectorAll('[data-kiive-home-refresh]').forEach(init); scheduleBackdrop(); }
  window.KiiveHomeRefresh = { boot };
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-kiive-home-refresh]').forEach(root => { const destroy = instances.get(root); if (destroy) destroy(); }); scheduleBackdrop(); });
  document.addEventListener('shopify:section:reorder', scheduleBackdrop);
  window.addEventListener('resize', scheduleBackdrop, { passive: true });
  boot(document);
})();
